import CarouselCard from '../CarouselCard/CarouselCard';

function NewYearsGiftCard() {
  const href = 'https://share.zenbusiness.com/new-year-2026-100-carousel-ad';

  return (
    <CarouselCard
      imageSrc="/s2/raster/refer-friend-both-100-december-campaign.png"
      imageAltId="dashboard.carousel.card.newYearsGift.imageAlt"
      titleId="dashboard.carousel.card.newYearsGift.title"
      subtitleId="dashboard.carousel.card.newYearsGift.subTitle"
      buttonTextId="dashboard.carousel.card.newYearsGift.button"
      href={href}
      elementName="carousel_new_years_gift_link"
      target="_blank"
    />
  );
}

export default NewYearsGiftCard;
